const dev = {
  cognito: {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_42StTlIv3",
    APP_CLIENT_ID: "5atp64gdek1rg3msfdp2f089q2",
    IDENTITY_POOL_ID: "us-east-1:83b7a7dc-2178-4691-8d64-86bb83d775d3"
  }
};

const prod = {
  cognito: {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_42StTlIv3",
    APP_CLIENT_ID: "5atp64gdek1rg3msfdp2f089q2",
    IDENTITY_POOL_ID: "us-east-1:83b7a7dc-2178-4691-8d64-86bb83d775d3"
  }
};

// Default to dev if not set
const config = process.env.REACT_APP_STAGE === 'prod'
  ? prod
  : dev;

export default {
  // Add common config values here
  MAX_ATTACHMENT_SIZE: 5000000,
  ...config
};
